import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ColorId, ColorIds, ColorState } from './color.types';

const initialState: ColorState = {
  byId: {},
  usableIds: [],
};

const colorSlice = createSlice({
  name: 'color',
  initialState,
  reducers: {
    updateColorsIds: (state, action: PayloadAction<ColorIds>) => {
      state.byId = action.payload.byId;
      state.usableIds = action.payload.usableIds;
    },
    updateSelectedColorId: (state, action: PayloadAction<ColorId>) => {
      state.selectedColorId = action.payload;
    },
    resetSelectedColorId: (state) => {
      state.selectedColorId = undefined;
    },
    updateRestorableColorId: (
      state,
      action: PayloadAction<ColorId | undefined>
    ) => {
      state.restorableColorId = action.payload;
    },
  },
});

export const {
  resetSelectedColorId,
  updateColorsIds,
  updateSelectedColorId,
  updateRestorableColorId,
} = colorSlice.actions;

export default colorSlice.reducer;
